module.exports = __webpack_public_path__ + "static/media/contract-manufacturing.bbe8f61d.svg";